import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import calls from './backend/api-calls'
import './../node_modules/bulma/css/bulma.min.css';
import './filters'
import { Datepicker, Datetimepicker, Field } from 'buefy'
import * as Sentry from "@sentry/vue";

Vue.use(Datepicker)
Vue.use(Datetimepicker)
Vue.use(Field)

Vue.config.productionTip = false
Vue.prototype.$http = calls;

Sentry.init({
  Vue,
  dsn: "https://6c584c54dfc04f2ec16a0d4ba0512638@sentry.realretina.com/3",
  integrations: [
    new Sentry.BrowserTracing(),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
